export default "__VITE_ASSET__DTapQwKj__"